let initialState = {
    fullImageViewModalStatus: false,
    fullImageViewModalParams: [],
};

export default function ModalReducer(state = initialState, action) {
    if (action.type === 'fullImageViewModal') {
        return Object.assign({}, state, {
            fullImageViewModalStatus: action.payload.fullImageViewModalStatus,
            fullImageViewModalParams: action.payload.fullImageViewModalParams,
        });
    }else {
        return state;
    }
}
